import React, { useState, useEffect } from 'react';
import { Phone } from 'lucide-react';

const Office24BY7Landing = () => {
  const words = ['Empower', 'Innovate', 'Advance'];
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [currentText, setCurrentText] = useState('');
  const [isTyping, setIsTyping] = useState(true);

  useEffect(() => {
    const currentWord = words[currentWordIndex];
    if (isTyping) {
      if (currentText.length < currentWord.length) {
        const timeout = setTimeout(() => {
          setCurrentText(currentWord.slice(0, currentText.length + 1));
        }, 150);
        return () => clearTimeout(timeout);
      } else {
        const timeout = setTimeout(() => {
          setIsTyping(false);
        }, 2000);
        return () => clearTimeout(timeout);
      }
    } else {
      if (currentText.length > 0) {
        const timeout = setTimeout(() => {
          setCurrentText(currentText.slice(0, -1));
        }, 100);
        return () => clearTimeout(timeout);
      } else {
        setCurrentWordIndex((prev) => (prev + 1) % words.length);
        setIsTyping(true);
      }
    }
  }, [currentText, isTyping, currentWordIndex, words]);

  return (
    <div
      className="min-h-screen"
      style={{ background: 'linear-gradient(135deg, #f3f4f6 0%, #e0e7ef 100%)' }}
    >
      {/* Header */}
      <header
        className="shadow-sm"
        style={{ backgroundColor: '#ffff' }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            {/* Logo */}
            <div className="flex items-center">
              <div className="flex items-center space-x-2">
                <div
                  className="w-10 h-10 rounded-full flex items-center justify-center"
                  style={{
                    background: 'linear-gradient(90deg, #3B82F6, #8B5CF6)'
                  }}
                >
                  <div className="w-6 h-6 bg-white rounded-full flex items-center justify-center">
                    <div
                      className="w-3 h-3 rounded-full"
                      style={{
                        background: 'linear-gradient(90deg, #3B82F6, #8B5CF6)'
                      }}
                    ></div>
                  </div>
                </div>
                <div>
                  <span
                    className="text-xl font-bold"
                    style={{ color: '#111827' }}
                  >
                    OFFICE
                  </span>
                  <span
                    className="text-sm ml-1"
                    style={{ color: '#64748b' }}
                  >
                    24BY7
                  </span>
                </div>
              </div>
            </div>
            {/* Right side */}
            <div className="flex items-center space-x-4">
              <div className="flex items-center space-x-2" style={{ color: '#334155' }}>
                <Phone className="w-4 h-4" />
                <span className="text-sm">+91 70971 71717</span>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
        {/* Hero Section */}
        <div className="text-center mb-16 ">
          <h1
            className="text-5xl md:text-6xl font-bold mb-6"
            style={{ color: '#1e293b' }}
          >
            Scale, Grow, and{' '}
            <span
              style={{
                background: 'linear-gradient(45deg, #8B5CF6, #3B82F6)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}
              className='text-5xl md:text-6xl'
            >
              {currentText}
              <span className="animate-pulse">|</span>
            </span>
          </h1>

          <p
            className="text-xl mb-4 max-w-4xl mx-auto text-center"
            style={{ color: '#334155' }}
          >
            The all-in-one solution to manage communication, sales, marketing, customer
          </p>
          <p
            className="text-xl mb-8 max-w-4xl mx-auto text-center"
            style={{ color: '#334155' }}
          >
            support, operations, projects, and all other organizational workflows.
          </p>

          <p
            className="text-lg font-medium mb-12 text-center"
            style={{ color: '#475569' }}
          >
            Make happy customers, make happy teams!
          </p>

          {/* Dashboard Image */}
          <div className="mb-16">
            <img
              src="https://ik.imagekit.io/kqumni8l2/kcs-products/Office24by7/office24by7%20image.png?updatedAt=1751604228559"
              alt="Office 24BY7 Dashboard Preview"
              className="w-full max-w-5xl mx-auto rounded-lg shadow-2xl"
              style={{ backgroundColor: '#f3f4f6' }}
            />
          </div>
        </div>
      </main>
    </div>
  );
};

export default Office24BY7Landing;



// import React, { useState, useEffect } from 'react';
// import { Phone, Facebook, Twitter, Instagram, Linkedin, Youtube, MapPin, ChevronDown } from 'lucide-react';

// const Office24BY7Replica = () => {
//   const words = ['Advance'];

//   const [currentWordIndex, setCurrentWordIndex] = useState(0);
//   const [currentText, setCurrentText] = useState('');
//   const [isTyping, setIsTyping] = useState(true);

//   useEffect(() => {
//     const currentWord = words[currentWordIndex];
//     if (isTyping) {
//       if (currentText.length < currentWord.length) {
//         const timeout = setTimeout(() => {
//           setCurrentText(currentWord.slice(0, currentText.length + 1));
//         }, 150);
//         return () => clearTimeout(timeout);
//       } else {
//         const timeout = setTimeout(() => {
//           setIsTyping(false);
//         }, 2000);
//         return () => clearTimeout(timeout);
//       }
//     } else {
//       if (currentText.length > 0) {
//         const timeout = setTimeout(() => {
//           setCurrentText(currentText.slice(0, -1));
//         }, 100);
//         return () => clearTimeout(timeout);
//       } else {
//         setCurrentWordIndex((prev) => (prev + 1) % words.length);
//         setIsTyping(true);
//       }
//     }
//   }, [currentText, isTyping, currentWordIndex, words]);

//   return (
//     <div className="min-h-screen bg-white">
     

//       {/* Main Header */}
//       <header className="bg-gradient-to-r from-purple-600 to-purple-700" style={{ backgroundColor: '#8B5CF6' }}>
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="flex justify-between items-center py-4">
//             {/* Logo */}
//             <div className="flex items-center">
//               <div className="flex items-center space-x-3">
//                 <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center">
//                   <div className="w-6 h-6 bg-gradient-to-r from-purple-600 to-blue-500 rounded-full flex items-center justify-center">
//                     <div className="w-3 h-3 bg-white rounded-full"></div>
//                   </div>
//                 </div>
//                 <div>
//                   <span className="text-2xl font-bold text-white">OFFICE</span>
//                   <span className="text-sm text-purple-200 ml-1">24BY7</span>
//                 </div>
//               </div>
//             </div>

           
//             {/* Right side */}
//             <div className="flex items-center space-x-4">
//               <div className="flex items-center space-x-2 text-white">
//                 <Phone className="w-4 h-4" />
//                 <span className="text-sm font-medium">+91 8889992186</span>
//               </div>
              
//             </div>
//           </div>
//         </div>
//       </header>

//       {/* Main Content */}
//       <main className="bg-gray-50 py-20">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           {/* Hero Section */}
//           <div className="text-center mb-16">
//             <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-8 text-gray-900">
//               Scale, Grow, and{' '}
//               <span className="text-purple-600 text-5xl md:text-6xl lg:text-7xl">
//                 {currentText}
//                 <span className="animate-pulse ">|</span>
//               </span>
//             </h1>

//             <p className="text-xl text-gray-600 mb-2 max-w-4xl mx-auto">
//               The all-in-one solution to manage communication, sales, marketing, customer
//             </p>
//             <p className="text-xl text-gray-600 mb-8 max-w-4xl mx-auto">
//               support, operations, projects, and all other organizational workflows.
//             </p>

//             <p className="text-lg font-medium text-gray-700 mb-16">
//               Make happy customers, make happy teams!
//             </p>

           
//           </div>
//         </div>
//       </main>

//       {/* WhatsApp Button */}
//       <div className="fixed bottom-6 right-6 z-50">
//         <div className="w-14 h-14 bg-green-500 rounded-full flex items-center justify-center shadow-lg hover:bg-green-600 transition-colors cursor-pointer">
//           <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
//             <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.893 3.488"/>
//           </svg>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Office24BY7Replica;